import Navbar from "../Navbar/Navbar"
import Cart from "./Cart"

export default function ProductCart() {
    return (
        <>
            <Navbar />
            <>
            <Cart />
            </>
        </>
    )
}